// validationUtils.js
export const validateField = (key: string, value: any) => {
  let error = null;

  // Define common validation rule
  const containsLettersRegex = /[a-zA-Z]/;

  // Fields that should follow the same validation rule
  const fieldsWithLetterValidation = [
    "project_name",
    "project_brief",
    "core_deliverables",
    "consulting_company",
    "core_deliverables",
  ];

  if (fieldsWithLetterValidation.includes(key)) {
    if (value && !containsLettersRegex.test(value)) {
      error = `Please enter a valid input`;
    } else {
      error = null;
    }
  }

  // Specific validation for email
  if (key === "project_lead_email") {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let trimmedValue = null;

    if (value) {
      trimmedValue = value.trim();
    }

    if (trimmedValue && !emailRegex.test(trimmedValue)) {
      error = "Please enter a valid email address.";
    } else {
      error = null;
    }
  }
  if (key === "project_lead_name") {
    const projectLeadRegex = /^[a-zA-Z\s]+$/;

    if (value && !projectLeadRegex.test(value)) {
      error = "Please enter a valid input.";
    } else {
      error = null;
    }
  }
  return error;
};
export const sqlKeyValidation = (key: string, value: any) => {
  const listofkeys = [
    "project_name",
    "Project_brief",
    "core_deliverables",
    "consultingCompany",
    "projectLead",
    "projectLeadEmail",
  ];
  const disallowedKeywords = [
    "SELECT",
    "INSERT",
    "UPDATE",
    "DELETE",
    "DROP",
    "ALTER",
    "TRUNCATE",
    "EXEC",
    "UNION",
    "GRANT",
    "REVOKE",
    "COMMIT",
    "ROLLBACK",
    "CREATE",
    "WHERE",
    "TABLE",
    "DATABASE",
    "SCRIPT",
    "--",
    ";",
    "'",
    '"',
  ];
  let error = null;

  if (listofkeys.includes(key)) {
    const disallowedRegex = new RegExp(
      `\\b(${disallowedKeywords.join("|")})\\b|;|'|\"|--`,
      "i" // Case insensitive
    );
    if (value && disallowedRegex.test(value)) {
      error = "Your input contains disallowed keywords. Please remove them.";
    } else {
      error = null;
    }
  }
  return error;
};
